import React from "react";
import HouseList from "../components/houses/HouseList";
import Navbar from "../components/Navbar";

const Properties = () => {
  return (
    <div className="properties-page-container">
      <Navbar />
      <div>
        <h2>Pagina en Construcción</h2>
      </div>
      <div className="filters-container">
        <div>
          <a>En Venta</a>
        </div>
        <div>
          <a>En Arriendo</a>
        </div>
        <div>
          <a>Precio</a>
        </div>
      </div>
      <div className="properties-page-houses-container">
        <HouseList />
      </div>
    </div>
  );
};
export default Properties;
